<template>
  <EmptyLayout>
    <div :class="$style.container" class="grid grid-cols-2 gap-6">
      <div>
        <SCALogo variant="wordmark" :class="$style.logo" />
        <h1 class="mb-4">404</h1>
        <p>{{ $t("common.label.pageFound") }}</p>
      </div>
      <div class="flex justify-end items-end">
        <RouterLink :to="{ name: Routes.HOME }">
          <SCAButton appearance="secondary" intent="none" icon-left="phosphor/house" size="large">
            {{ $t("common.action.backHome") }}
          </SCAButton>
        </RouterLink>
      </div>
    </div>
  </EmptyLayout>
</template>

<script lang="ts" setup>
import { SCAButton, SCALogo } from "@scayla/components";

import EmptyLayout from "@/layouts/EmptyLayout.vue";
import { Routes } from "@/router";
</script>

<style module lang="scss">
.container {
  width: 100%;
  max-width: 600px;
  margin: var(--space-component-padding-6xLarge) auto;
  padding: var(--space-component-padding-5xLarge);
  border-radius: var(--border-radius-xLarge);
  background: var(--color-interaction-background-modal);
  box-shadow:
    0px 2px 2px -1px rgba(27, 36, 44, 0.04),
    0px 16px 24px -6px rgba(27, 36, 44, 0.16);
}
.logo {
  height: 32px;
  margin-bottom: var(--space-component-padding-4xLarge);
}

h1 {
  @include Globals.typo-header-4xlarge;
}

p {
  @include Globals.typo-body-large;
}
</style>
